"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var icons_1 = require("../../icons");
var utils_1 = require("../../utils");
var Tooltip_1 = tslib_1.__importDefault(require("../../Tooltip"));
function SortIcon(_a) {
    var parentPrefix = _a.prefix, order = _a.order, onSort = _a.onSort;
    var prefix = utils_1.concat(parentPrefix, 'sort');
    var sorted = order !== 'none';
    var cls = classnames_1.default(prefix, sorted && utils_1.concat(prefix, order === 'desc' ? 'desc' : 'asc'));
    var handleClick = react_1.useCallback(function () { return onSort(getNextOrder(order)); }, [onSort, order]);
    return (react_1.default.createElement(Tooltip_1.default, { title: getTitle(order) },
        react_1.default.createElement("span", { className: cls, onClick: handleClick },
            react_1.default.createElement(icons_1.UpTriangleIcon, null),
            react_1.default.createElement(icons_1.DownTriangleIcon, { style: { marginTop: '-3px' } }))));
}
exports.default = SortIcon;
var orders = ['asc', 'desc', 'none'];
function getNextOrder(order) {
    var index = orders.indexOf(order);
    var nextIndex = (index + 1) % orders.length;
    return orders[nextIndex];
}
var orderDescMap = {
    asc: '点击升序',
    desc: '点击降序',
    none: '取消排序'
};
function getTitle(order) {
    return orderDescMap[getNextOrder(order)];
}
//# sourceMappingURL=index.js.map